import { inject, Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import {
  ApiPaginationResult,
  ApiResult,
} from '../../shared/models/api-result.model';
import { CreateTaxRate, UpdateTaxRate } from '../models/tax-rate.model';

@Injectable({
  providedIn: 'root',
})
export class TaxRateService {
  private http = inject(HttpClient);

  apiBaseUrl = environment.apiBaseUrl;

  getAll(
    pageNumber: number,
    pageSize: number,
    country?: string,
    state?: string,
    city?: string,
  ) {
    let params = new HttpParams()
      .set('pageNumber', pageNumber)
      .set('pageSize', pageSize);

    if (country) params = params.set('country', country);
    if (state) params = params.set('state', state);
    if (city) params = params.set('city', city);

    return this.http.get<ApiPaginationResult>(
      this.apiBaseUrl + '/api/v1/tax-rates',
      { params },
    );
  }

  getById(id: string) {
    return this.http.get<ApiResult>(
      this.apiBaseUrl + '/api/v1/tax-rates/' + id,
    );
  }

  create(data: CreateTaxRate) {
    return this.http.post<ApiResult>(
      this.apiBaseUrl + '/api/v1/tax-rates',
      data,
    );
  }

  update(id: string, data: UpdateTaxRate) {
    return this.http.put<ApiResult>(
      this.apiBaseUrl + '/api/v1/tax-rates/' + id,
      data,
    );
  }
}
